import React, { PropsWithChildren } from 'react';
import { WixDesignSystemProvider } from '@wix/design-system';

import '@wix/design-system/styles.global.css';

export const DesignContextProvider = ({ children }: PropsWithChildren) => {
  return <WixDesignSystemProvider features={{ newColorsBranding: true }}>{children}</WixDesignSystemProvider>;
};
